import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbButtonAppearance, NbDialogService, NbThemeService } from '@nebular/theme';
import { resourceTypes } from '@shared/constants/resourceTypes';
import { IUserProfile } from '@shared/interfaces/user/user-profile';
import { AddMoreResourcesModalComponent } from '@shared/modules/account/modals/add-more-resources-modal/add-more-resources-modal.component';
import { DeviceAddModalComponent } from '@shared/modules/device/modals/device-add-modal/device-add-modal.component';
import { AlertService } from '@shared/services/alert.service';
import { ApiService } from '@shared/services/api.service';
import { UserService } from '@shared/modules/account/services/user.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-empty-devices-list',
  templateUrl: './empty-devices-list.component.html',
  styleUrls: ['./empty-devices-list.component.scss']
})
export class EmptyDevicesListComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();
  currentUser: IUserProfile;

  protected settingsButton: { appearance: NbButtonAppearance, status: string };

  constructor(
    private readonly api: ApiService,
    private readonly dialogService: NbDialogService,
    private readonly alertService: AlertService,
    private readonly userService: UserService,
    private readonly themeService: NbThemeService
  ) {
    this.currentUser = {} as IUserProfile;
  }

  ngOnInit() {
    this.subscription.add(
      this.userService.user$.subscribe(user => {
        if (user) this.currentUser = user;
      })
    );

    this.subscription.add(
      this.themeService
        .getJsTheme()
        .subscribe(res => {
          this.settingsButton = {
            appearance: res.variables!['dashboardSettingsButtonAppearance'] as NbButtonAppearance,
            status: res.variables!['dashboardSettingsButtonStatus'] as string
          }
        })
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onCreateModalDeviceAdd(): void {
    this.subscription.add(
      this.api.getDevicesResources().subscribe(res => {
        if (res.totalDeviceCount - res.currentDeviceCount > 0) {
          this.dialogService.open<any>(DeviceAddModalComponent, {});
        } else {
          this.dialogService.open<any>(AddMoreResourcesModalComponent, {
            context: {
              resource: resourceTypes.devices,
              currentCount: res.currentDeviceCount,
              totalCount: res.totalDeviceCount,
              totalLimit: res.totalDevicesLimit,
              priceForOneUnit: res.priceForOneUnit,
              currency: res.currency,
              title: "common.add-new-device",
              icon: "plus-outline",
              isActive: res.isActive
            }
          });
        }
      })
    );
  }
}
